import { Component, Input , Inject} from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrintPdfService } from "src/app/service/print-pdf.service";

@Component({
    selector: "app-pdf-modal",
    templateUrl: "./pdf-modal.component.html",
    styleUrls: ["./pdf-modal.component.scss"],
    standalone: false
})
export class PdfModalComponent {
  public positionPdfViewerRelative: boolean = false;
  pdfIsLoading: boolean = true;
  /** somehow print does not work when it has not been viewed yet.
   * This is to render this component without using dialog.open.
   */
  @Input() set alternateData(pdfUrl: string) {
    if (!this.data) {
      this.data = {
        pdfUrl,
        fileType: "application/pdf",
        filename: "test.pdf",
      };
    }
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public prntr: PrintPdfService,
    private dialogRef: MatDialog
  ) {}


  print() {
    this.prntr.startPrint(this.data?.pdfUrl, this.data?.filename);
  }

  download() {
    this.prntr.startDownload(
      this.data?.pdfUrl,
      this.data?.fileType,
      this.data?.filename
    );
  }

  onProgress(evt: { loaded: number; total: number }) {
    const { loaded, total } = evt;
    if (loaded != total) {
      this.pdfIsLoading = true;
    } else {
      this.pdfIsLoading = false;
    }
  }

  pageRendered(evt) {
    this.pdfIsLoading = false;
  }

  /** open all links on new tab */
  textLayerRendered(e: CustomEvent) {
    const pdfReport = document.getElementById("pdf-modal-id");
    let externalLinks: HTMLAnchorElement[];

    if (pdfReport) {
      const collection = pdfReport.getElementsByTagName("a");
      externalLinks = [].slice.call(collection);
    }

    for (const link of externalLinks) {
      link.setAttribute("target", "_blank");
    }
  }

  close() {
    this.dialogRef.closeAll();
  }

  public handlePdfLoaded(): void {
    this.positionPdfViewerRelative = true;
  }
}
